module.exports = __webpack_public_path__ + "ba60f9593605beb7d61c09cdf8e5de2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/softbank.png
// module id = 79
// module chunks = 0